 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Account Policy
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryPolicyFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryPolicyFilterForm"
                            v-model="filtersPolicy.policyNo"
                            :label="filtersPolicyLabel.policyNo"
                            :error-messages="errors.collect('filterPolicy')"
                            data-vv-name="filterPolicy"
                            :data-vv-as="filtersPolicyLabel.policy"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearPolicyFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doPolicyFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2" v-if="callerPage === 'MatchLater'">
        <v-data-table
          :headers="bmPolHeaders"
          :items="acctPolicyItems"
          v-bind:options.sync="paginationPolicy"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPol"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.policyNo }}</td>
              <td>{{ row.item.renCnt }}</td>
              <td>{{ row.item.endtCnt }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignPolicy(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 class="mt-2" v-else>
        <v-data-table
          :headers="polHeaders"
          :items="acctPolicyItems"
          v-bind:options.sync="paginationPolicy"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsPol"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.policyNo }}</td>
              <td>{{ row.item.renCnt }}</td>
              <td>{{ row.item.endtCnt }}</td>
              <td>{{ row.item.acctNo }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignPolicy(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      filtersPolicyLabel: {
        policyNo: 'Policy'
      },
      filtersPolicy: {
        policyNo: undefined,
        accountNo: undefined,
        extraTranGrp: undefined,
        extraModuleRequest: undefined,
        noBlankAcctNo: undefined
      },
      acctPolicyItems: [],
      totalItemsPol: 0,
      polHeaders: [
        { text: 'Policy No.', align: 'left', value: 'policyNo' },
        { text: 'Ren Count', align: 'left', value: 'renCnt' },
        { text: 'Endt Count', align: 'left', value: 'endtCnt' },
        { text: 'Account No.', align: 'left', value: 'acctNo' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      bmPolHeaders: [
        { text: 'Policy No.', align: 'left', value: 'policyNo' },
        { text: 'Ren Count', align: 'left', value: 'renCnt' },
        { text: 'Endt Count', align: 'left', value: 'endtCnt' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationPolicy: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    boolPolRefresh: function (value) {
      if (value) {
        this.doClearPolicyFilters()
      }
    },
    'paginationPolicy': function (value) {
      this.fetchAcctPolicyData(this.callerPage)
    }
  },
  mounted() {
  },
  methods: {
    closeDialog() {
      this.filtersPolicy.policyNo = ''
      this.$emit('close')
    },
    doClearPolicyFilters() {
      this.filtersPolicy.policyNo = ''
      if (this.callerPage === 'MatchLater') {
        this.filtersPolicy.multiFundSfxCurr = this.multiFundSfxCurr
        this.filtersPolicy.accountNo = this.accountNo
        this.filtersPolicy.fund = this.fund
        this.filtersPolicy.acctNoSfx = this.acctNoSfx
        this.filtersPolicy.curr = this.curr
      } else {
        this.filtersPolicy.accountNo = this.accountNo
        this.filtersPolicy.extraTranGrp = this.extraTranGrp
        this.filtersPolicy.extraModuleRequest = this.extraModuleRequest
        this.filtersPolicy.noBlankAcctNo = this.noBlankAcctNo
      }
      this.fetchAcctPolicyData(this.callerPage)
    },
    doPolicyFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryPolicyFilterForm').then((result) => {
        if (result) {
          this.paginationPolicy.page = 1
          if (this.callerPage === 'MatchLater') {
            this.filtersPolicy.multiFundSfxCurr = this.multiFundSfxCurr
            this.filtersPolicy.accountNo = this.accountNo
            this.filtersPolicy.fund = this.fund
            this.filtersPolicy.acctNoSfx = this.acctNoSfx
            this.filtersPolicy.curr = this.curr
          } else {
            this.filtersPolicy.accountNo = this.accountNo
            this.filtersPolicy.extraTranGrp = this.extraTranGrp
            this.filtersPolicy.extraModuleRequest = this.extraModuleRequest
            this.filtersPolicy.noBlankAcctNo = this.noBlankAcctNo
          }
          this.fetchAcctPolicyData(this.callerPage)
        }
      })
    },
    assignPolicy(data) {
      // Use $emit to call parent Accounts page method assignCurrency and pass the value
      this.$emit('assign-policy-info', data)
      this.$emit('assign-policy', data.policyNo)
      this.$emit('close')
    }
  },
  props: {
    boolPolRefresh: {
      type: Boolean,
      default: true
    },
    accountNo: {
      type: String,
      default: ''
    },
    extraTranGrp: {
      type: Number,
      default: 0
    },
    extraModuleRequest: {
      type: String,
      default: ''
    },
    noBlankAcctNo: {
      type: String,
      default: ''
    },
    callerPage: {
      type: String,
      default: ''
    },
    multiFundSfxCurr: {
      type: Boolean,
      default: false
    },
    fund: {
      type: String,
      default: ''
    },
    acctNoSfx: {
      type: String,
      default: ''
    },
    curr: {
      type: String,
      default: ''
    }
  },
  computed: {},
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
